// @ts-nocheck
import { useState } from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { Plus, Search, Globe, RefreshCw, Edit } from 'lucide-react'
import { apiService } from '../services/api'
import { authService } from '../services/auth'

const Zones = () => {
  const navigate = useNavigate()
  const [searchQuery, setSearchQuery] = useState('')
  const isAdmin = authService.isAdmin()

  const { data: zones, isLoading, refetch } = useQuery(
    'zones',
    () => apiService.getZones(),
    { refetchInterval: 30000 }
  )

  const filteredZones = zones?.data?.filter((zone: any) =>
    zone.name?.toLowerCase().includes(searchQuery.toLowerCase())
  ) || []

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-slate-900">DNS Zones</h2>
          <p className="text-slate-500">Manage DNS zones and records from the database view</p>
        </div>
        <div className="flex items-center space-x-3">
          <button onClick={() => refetch()} className="p-2 text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg">
            <RefreshCw className="h-5 w-5" />
          </button>
          {isAdmin && (
            <button onClick={() => navigate('/zones/new')} className="flex items-center space-x-2 px-4 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700">
              <Plus className="h-4 w-4" />
              <span>Add Zone</span>
            </button>
          )}
        </div>
      </div>

      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
        <input
          type="text"
          placeholder="Search zones..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
        />
      </div>

      {isLoading ? (
        <div className="h-64 bg-slate-100 rounded-xl animate-pulse" />
      ) : filteredZones.length === 0 ? (
        <div className="text-center py-12">
          <Globe className="h-12 w-12 text-slate-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-slate-900">No zones found</h3>
          <p className="text-slate-500 mt-1">Import existing zones or create a new zone.</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
          <table className="min-w-full divide-y divide-slate-200">
            <thead className="bg-slate-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase text-slate-500">Zone</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase text-slate-500">Type</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase text-slate-500">Records</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase text-slate-500">Serial</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase text-slate-500">TTL</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase text-slate-500">Status</th>
                <th className="px-4 py-3 text-right text-xs font-semibold uppercase text-slate-500">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-200">
              {filteredZones.map((zone: any) => (
                <tr key={zone.id} className="hover:bg-slate-50">
                  <td className="px-4 py-3 text-sm font-medium text-slate-900">{zone.name}</td>
                  <td className="px-4 py-3 text-sm text-slate-600 capitalize">{zone.type || 'master'}</td>
                  <td className="px-4 py-3 text-sm text-slate-600">{zone.record_count || 0}</td>
                  <td className="px-4 py-3 text-sm text-slate-600">{zone.serial || 'N/A'}</td>
                  <td className="px-4 py-3 text-sm text-slate-600">{zone.ttl || 3600}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${zone.is_active ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-600'}`}>
                      {zone.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right">
                    <button onClick={() => navigate(`/zones/${zone.id}`)} className="p-2 text-sky-600 hover:bg-sky-50 rounded-lg" title="Manage records">
                      <Edit className="h-4 w-4" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default Zones
